<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="编辑"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap" v-loading="dataLoading">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="150px">
                <el-form-item label="kpi维度（场景）：">
                    <div>
                        <span>{{modalData.delivery_scene_text}}</span>
                    </div>
                </el-form-item>
                <el-form-item label="游戏分类：">
                    <div>
                        <span>{{modalData.game_classify}}</span>
                        <span class="text-color-gray ml20 pointer font12px" @click="toAppPage">分类有问题？点击去更新</span>
                    </div>
                </el-form-item>
                <el-form-item label="分包类型：" prop="subpackage_type">
                    <el-select v-model="formItem.subpackage_type" clearable placeholder="请选择分包类型" style="width: 300px;">
                        <el-option label="分包" value="1"></el-option>
                        <el-option label="联运包" value="2"></el-option>
                        <el-option label="官包" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="每日预算：" prop="budget">
                    <el-input v-model="formItem.budget" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                </el-form-item>
                <template v-if="modalData.game_classify=='iap'||modalData.game_classify=='IAP'">
                    <el-form-item label="注册成本：" prop="register_price">
                        <el-input v-model="formItem.register_price" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                    </el-form-item>
                    <el-form-item label="新增付费成本：" prop="new_cost_price">
                        <el-input v-model="formItem.new_cost_price" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                    </el-form-item>
                    <el-form-item label="新增付费率：" prop="new_cost_rate">
                        <el-input v-model="formItem.new_cost_rate" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">%</span>
                    </el-form-item>
                    <el-form-item label="首日内购ROI：" prop="pay_roi1">
                        <el-input v-model="formItem.pay_roi1" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">%</span>
                    </el-form-item>
                </template>
                <template v-else-if="modalData.game_classify=='iaa'||modalData.game_classify=='IAA'">
                    <el-form-item label="激活成本：" prop="active_price">
                        <el-input v-model="formItem.active_price" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">元</span>
                    </el-form-item>
                    <el-form-item label="首日变现ROI：" prop="ad_monetization_roi_1">
                        <el-input v-model="formItem.ad_monetization_roi_1" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">%</span>
                    </el-form-item>
                </template>

                <el-form-item v-for="item in selectList" :prop="item.id" :key="item.id" :label="item.display_name+'：'">
                    <el-input v-model="formItem[item.id]" placeholder="请输入数字，支持2位小数" style="width: 300px;"></el-input> <span class="suffix-text">{{item.config.type=='percent'?'%':item.config.type=='price'?'元':''}}</span>
                </el-form-item>

            </el-form>
            <div class="tac">
                <el-button size="mini" type="primary" plain @click="addKpiField" class="action-btn mr20">增加KPI指标</el-button>
            </div>
        </div>
        <div slot="title">
            <p>
                <span class="font14px text-bold">编辑</span>
                <span class="text-color-gray ml10">{{modalData.app_name}}</span>
            </p>
        </div>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit('next')" :loading="submitLoading" :disabled="isLastRow||noGameClassify" size="mini" class="action-btn mr20" plain>保存&编辑下一个</el-button>
            <el-button type="primary" @click="handleSubmit('close')" :loading="submitLoading" :disabled="noGameClassify" class="action-btn ml20">保存并关闭</el-button>
        </div>
        <KpiFieldModal ref="kpiFieldModal" :config="configData"  :select-list="selectList" @save="saveSelectList" />
    </el-dialog>
</template>

<script>
    import KpiFieldModal from './kpiFieldModal';
    import API from '@/api/dataCenter/appKpi.js';
    export default {
        name: "EditKpiModal",
        components:{
            KpiFieldModal,
        },
        props:{
            modalData:Object,
            config:Array,
            platId:[String,Number],
            isLastRow:Boolean,
        },

        data(){
            let validateNum = (rule, value, callback) => {
                if (value===0||value==='0'||parseFloat(''+value)===0) {
                    return callback(new Error('不能设置为0'));
                }
                if (!value) {
                    callback();
                }else if(isNaN(value)){
                    return callback(new Error('请输入数值'));
                }else if(value==0){
                    return callback(new Error('不能设置为0'));
                } else if(Number.isInteger(value)) {
                    callback();
                }else if((value+'').includes('.')){
                    let num = (value+'').split('.')[1].length;
                    if (num > 2) {
                        return callback(new Error('小数点不能超过2位'));
                    } else {
                        callback();
                    }
                }else{
                    callback();
                }
            };

            return {
                dialogVisible:false,
                submitLoading:false,
                dataLoading:false,
                formItem:{
                    delivery_scene:'',
                    delivery_type:'',
                    subpackage_type:'',
                    budget:'',
                    register_price:'',
                    new_cost_price:'',
                    new_cost_rate:'',
                    pay_roi1:'',
                    ad_monetization_roi_1:'',
                    active_price:'',
                },
                selectList:[],
                rules:{
                    subpackage_type:[
                        { required: true, message: '请选择分包类型', trigger: 'change' }
                    ],
                    budget:[
                        { required: true, message: '请输入每日预算', trigger: 'blur' },
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    register_price:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    new_cost_price:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    new_cost_rate:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    pay_roi1:[
                        { validator: validateNum, trigger: 'blur' },
                    ],
                    cli_price:[{ validator: validateNum, trigger: 'blur' },],
                    download_price:[{ validator: validateNum, trigger: 'blur' },],
                    active_price:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention1_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention3_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention7_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention14_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_retention30_rate:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi3:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi7:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi30:[{ validator: validateNum, trigger: 'blur' },],
                    pay_roi:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv1:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv3:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv7:[{ validator: validateNum, trigger: 'blur' },],
                    pay_ltv30:[{ validator: validateNum, trigger: 'blur' },],
                    week_pay_roi:[{ validator: validateNum, trigger: 'blur' },],
                    month_pay_roi:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi1:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi3:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi7:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi30:[{ validator: validateNum, trigger: 'blur' },],
                    pay_income_roi:[{ validator: validateNum, trigger: 'blur' },],
                    ad_monetization_roi_1:[{ validator: validateNum, trigger: 'blur' },],
                }
            }
        },
        computed:{
            configData(){
                return (this.config||[]).map(item=>{
                    let group = {};
                    group.checked = false;
                    group.indeterminate = false;
                    group.config = JSON.parse(item.config||'{}');
                    group.display_name = item.display_name;
                    group.id = item.id;
                    group.pid = item.pid;
                    group.disabled = this.requiredList.includes(item.id);
                    let children = item.children||[];
                    let selectList = this.selectList.map(item=>item.id);
                    if(children.length>0){
                        group.children = children.map(inner=>{
                            return {
                                checked:this.requiredList.concat(selectList).includes(inner.id),
                                config:JSON.parse(inner.config||'{}'),
                                disabled:this.requiredList.includes(inner.id),
                                display_name:inner.display_name,
                                id:inner.id,
                                pid:inner.pid,
                            };
                        })
                    }
                    return group;
                })
            },
            allFields(){
                let list = [];
                this.configData.forEach(item=>{
                    list = list.concat(item.children||[]);
                });
                return list;
            },
            requiredList(){
                if(this.modalData.game_classify=='iaa'||this.modalData.game_classify=='IAA'){
                    return [
                        'delivery_scene',
                        'budget',
                        'subpackage_type',
                        'ad_monetization_roi_1',
                        'active_price',
                    ];
                }
                return [
                    'delivery_scene',
                    'subpackage_type',
                    'budget',
                    'register_price',
                    'new_cost_price',
                    'new_cost_rate',
                    'pay_roi1',
                ];
            },
            noGameClassify(){
                let type = this.modalData.game_classify;
                return !type||type=='未分配';
            },
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm() {
                this.selectList = [];
                this.formItem = {
                    delivery_scene:'',
                    subpackage_type:'',
                    budget:'',
                    register_price:'',
                    new_cost_price:'',
                    new_cost_rate:'',
                    pay_roi1:'',
                };
                this.$refs.form.resetFields();
            },
            showModal(){
                this.dialogVisible = true;
                this.formItem.delivery_scene = this.modalData.delivery_scene;
                this.formItem.delivery_type = this.modalData.delivery_type;
                this.$nextTick(()=>{
                    this.resetForm();
                    if(this.modalData.id){
                        this.getAppInfo();
                    }else{
                        /* 从列表直接获取的是文字，需要对应成id */
                        let valList = ['分包','联运包','官包'];
                        if(valList.includes(this.modalData.subpackage_type)){
                            let typeTxt = this.modalData.subpackage_type;
                            this.formItem.subpackage_type = typeTxt=='分包'?'1':typeTxt=='联运包'?'2':typeTxt=='官包'?'3':'';
                        }
                    }
                })
            },
            toAppPage(){
                console.log('toAppPage',this.modalData);
                // 点击文字新标签页打开，信息管理/标签管理/产品页面，并筛选对应媒体，对应推广ID，编辑框关闭
                this.handleClose();
                setTimeout(()=>{
                    let $router= this.$router.resolve({
                        name:'app_management_page',
                        query:{
                            plat_id:this.platId,
                            subproject_id:[this.modalData.app_id],
                        },
                    });
                    window.open($router.href, '_blank');
                },300)

            },
            getAppInfo(){
                this.dataLoading = true;
                API.getAppInfo({
                    id:this.modalData.id,
                    plat_id:this.platId,
                }).then(res=>{
                    this.dataLoading = false;
                    let resData = res.data||{};
                    if(resData.subpackage_type){
                        this.formItem.subpackage_type = resData.subpackage_type;
                    }
                    this.$set(this.formItem,'cli_price',resData.cli_price);
                    this.$set(this.formItem,'budget',resData.budget);
                    
                    this.selectList = [];
                    this.allFields.forEach(item=>{
                        if(this.requiredList.includes(item.id)){
                            this.$set(this.formItem,item.id,resData[item.id]||'');
                        }else if(resData[item.id]){
                            this.selectList.push(item);
                            this.$set(this.formItem,item.id,resData[item.id]);
                        }
                    });
                },err=>{
                    console.log('getAppInfo err',err);
                    this.dataLoading = false;
                })
            },
            handleSubmit(type){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let otherList = ['budget','subpackage_type','delivery_scene','delivery_type'];
                        let kpiList = Object.keys(this.formItem).filter(item=>!otherList.includes(item));
                        let kpiValues = kpiList.map(item=>{
                            return this.formItem[item];
                        });
                        if(kpiValues.every(item=>!item)) return this.$message.error('录入KPI目标至少需要录入其中一项');

                        this.submitLoading = true;
                        let reqData = {
                            plat_id:this.platId,
                            app_id:this.modalData.app_id,
                            delivery_type:this.modalData.delivery_type,
                            delivery_scene:this.modalData.delivery_scene,
                            id:this.modalData.id,
                        };

                        /* 过滤一下formItem里不需要的值 */
                        let selectListItem = this.selectList.map(item=>item.id);
                        let allFormList = [].concat(this.requiredList,selectListItem);
                        let formData = {};
                        Object.keys(this.formItem).forEach(item=>{
                            if(allFormList.includes(item)){
                                formData[item] = this.formItem[item];
                            }
                        });

                        API.editAppKpi(Object.assign({},formData,reqData)).then(res=>{
                            this.submitLoading = false;
                            let resData = res.data||{};
                            this.$message.success(res.info||'操作成功');
                            this.$emit('update',Object.assign({
                                subpackage_type:this.formItem.subpackage_type,
                            },resData),reqData);
                            if(type=='close'){
                                this.dialogVisible = false;
                            }else if(type=='next'){
                                this.$emit('next');
                                this.resetForm();
                            }
                        },err=>{
                            console.log('editAppKpi err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'操作失败');
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            addKpiField(){
                this.$refs.kpiFieldModal.showModal();
            },
            saveSelectList(list){
                this.selectList = list.map(item=>item);
                let formList = Object.keys(this.formItem);
                if(list.length<=0){
                    formList.forEach(item=>{
                        if(!this.requiredList.includes(item)){
                            delete this.formItem[item];
                        }
                    })
                }else{
                    list.forEach(item=>{
                        if(!formList.includes(item.id)){
                            this.$set(this.formItem,item.id,'');
                        }
                    });
                }
            },
            validateNum(rule, value, callback){
                if (value===0) {
                    return callback(new Error('不能设置为0'));
                }
                if(!value){
                    callback();
                } else if (isNaN(value)) {
                    return callback(new Error('请输入数值'));
                } else if(Number.isInteger(value)) {
                    return callback();
                }else if((value+'').includes('.')){
                    let num = (value+'').split('.')[1].length;
                    if (num > 2) {
                        return callback(new Error('小数点不能超过2位'));
                    } else {
                        callback();
                    }
                }
            },
        }

    }
</script>

<style lang="scss" scoped>
.content-wrap{
    max-height: 400px;
    overflow-y: auto;

    ::v-deep .el-input-number__decrease,::v-deep .el-input-number__increase{
        display: none;
    }
    .suffix-text{
        margin-left: 3px;
        font-size: 12px;
    }
}
</style>
